/* Cookies Function */
// import _ from 'lodash';

var dlabSettingsOptions = {
	typography: "poppins",
	theme_version: "dark",
	theme_layout: "horizontal",
	navigation_header: "color_11",
	header_bg: "color_11",
	sidebar_bg: "color_1",
	sidebar_position: "fixed",
	header_position: "fixed",
	sidebar_style: "full",
	container_layout: "wide",
	direction: "ltr",
	primary_bg: "color_8",	
};

var themeOptionArr = {
	typography: "",
	theme_version: "",
	theme_layout: "",
	navigation_header: "",
	header_bg: "",
	sidebar_bg: "",
	sidebar_position: "",
	header_position: "",
	sidebar_style: "",
	container_layout: "",
	direction: "",
	primary_bg: "",
	//direction: '',
};


export async function setCookie(cname, cvalue, exhours) 
	{
		var d = new Date();
		d.setTime(d.getTime() + (15*24*60*60*1000)); /* 30 Minutes */
		var expires = "expires="+ d.toString();
		document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
		return true;
	}

	export  function getCookie(cname) 
	{
		var name = cname + "=";
		var decodedCookie = decodeURIComponent(document.cookie);
		var ca = decodedCookie.split(';');
		for(var i = 0; i <ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			}
		}
		return "";
	}

	export  function deleteCookie(cname) 
	{
		var d = new Date();
		d.setTime(d.getTime() + (1)); // 1/1000 second
		var expires = "expires="+ d.toString();
		//document.cookie = cname + "=1;" + expires + ";path=/";
		document.cookie = cname + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT"+";path=/";
	}

	export	function deleteAllCookie()
	{
		Object.keys(themeOptionArr).forEach(function(key) {	
			 deleteCookie(key);		
		  });
		// themeOptionArr, function(optionKey, optionValue) {
		// 		deleteCookie(optionKey);
		// };
	
	}

	export async function  setThemeOptionOnPage()
	{
		// if(getCookie('version') != '')
		// {
			// _.forEach(themeOptionArr, function(optionKey, sKey) {
			// 	// if  (aIncludedFiles == null) {
			// 	//   return false;
			// 	// }
			// 	console.log('optionkey',optionKey)
			// 	var optionData = getCookie(optionKey);
			// 	console.log('cokkie=',optionData)
			// 	themeOptionArr[optionKey] = (optionData != '')?optionData:dlabSettingsOptions[optionKey];

			//   });

			  Object.keys(themeOptionArr).forEach(function(key) {

				// console.log('object',key,'data=', themeOptionArr[key]);
				var optionData = getCookie(key);
				themeOptionArr[key] = (optionData != '')?optionData:dlabSettingsOptions[key];

			  });


			// jQuery.each(themeOptionArr, function(optionKey, optionValue) {
			// 	var optionData = getCookie(optionKey);
			// 	themeOptionArr[optionKey] = (optionData != '')?optionData:dlabSettingsOptions[optionKey];
			// });
		
			dlabSettingsOptions = themeOptionArr;
			return dlabSettingsOptions;
			
			// setThemeLogo();
		//}
	}

// 	function set
// 	dlabSettingsOptions = {
// 		typography: "poppins",
// 		version: "light",
// 		layout: "vertical",
// 		primary: "color_1",
// 		headerBg: "color_1",
// 		navheaderBg: "color_1",
// 		sidebarBg: "color_1",
// 		sidebarStyle: "full",
// 		sidebarPosition: "fixed",
// 		headerPosition: "fixed",
// 		containerLayout: "full",
// 	};




// new dlabSettings(dlabSettingsOptions); 

	const exportObject =  {
		setCookie,getCookie,deleteCookie,setThemeOptionOnPage
	  };
	  export default exportObject;
